import { GroupBlockState } from './reducer';
import { RootState } from '../../../store';
import { logger } from '../../../server/logging';

interface State extends RootState {
  groupBlock: GroupBlockState;
}

export type GroupBlock = State['groupBlock'];
export type Blocks = State['groupBlock']['blocks'];

export const groupBlockSelector = ({ groupBlock }: State): GroupBlock => {
  // logger.debug('groupBlockSelector', groupBlock);
  return groupBlock;
}

export const blocksSelector = ({ groupBlock: { blocks } }: State): Blocks => { 
  // logger.debug('blocksSelector', blocks); 
  return blocks;
};